package modals

import camera.nfc.NfcService
import dev.fritz2.core.Store
import dev.fritz2.core.id
import dev.fritz2.core.placeholder
import dev.fritz2.core.values
import koin.withKoin
import kotlinx.coroutines.flow.flowOf
import kotlinx.coroutines.flow.map
import localization.TL
import localization.getTranslationFlow
import localization.translate
import mainmenu.Pages
import mainmenu.RouterStore
import qrcode.HasCameraStore
import qrcode.ScannedCodeStore
import signup.twTextButton
import theme.FormationIcons
import theme.FormationUIIcons
import twcomponents.twPrimaryButton
import twcomponents.twRowOf
import twcomponents.twSimpleModalWithCloseHeader
import twcomponents.twSubtitle
import utils.ToggleStore
import utils.focusInputObserver
import utils.getName
import webcomponents.genericInput

fun twTrackObjectModal(
    toggleShowModalStore: Store<Boolean>,
) {
    withKoin {
        val hasCameraStore: HasCameraStore = get()
        val routerStore: RouterStore = get()
        val scannedCodeStore: ScannedCodeStore = get()
        val nfcService: NfcService = get()

        twSimpleModalWithCloseHeader(
            title = TL.WorkPlaceTools.TRACKING,
            icon = FormationIcons.TrackedObject,
            toggleStore = toggleShowModalStore,
            closeHandlers = listOfNotNull(scannedCodeStore.reset),
        ) { closeModal, _, optionalCloseHandlers ->
            div(
                baseClass = "flex flex-col gap-3 w-full md:min-w-96 overflow-y-auto p-2",
                id = "template-modal",
            ) {
                // box for scrollable content
                div(
                    "flex flex-col w-full md:w-96 px-2 max-h-max gap-4 overflow-y-auto",
                ) {
                    val toggleManualInput = ToggleStore(false)

                    twRowOf {
                        twSubtitle(
                            icon = FormationIcons.NFC,
                        ) {
                            nfcService.data.map { nfcStatus ->
                                "NFC ${nfcStatus.getName()}"
                            }.renderText()
                        }
                        nfcService.data.render { nfcStatus ->
                            div("flex grow-0 shrink-0 basis-2.5 w-2.5 h-2.5 rounded-full") {
                                inlineStyle("--nfcColor: ${nfcStatus.color};")
                                className("bg-[var(--nfcColor)]")
                            }
                        }
                    }

                    hasCameraStore.data.render { hasCamera ->
                        twSubtitle {
                            translate(TL.CodeScanning.INSTRUCTIONS_OBJECT_SCANNER)
                        }
                        twPrimaryButton(
                            text = TL.CodeScanning.START_SCAN,
                            icon = FormationUIIcons.ScanQR,
                            disabledFlow = flowOf(!hasCamera),
                        ) {
                            clicks handledBy {
                                routerStore.validateInternalRoute(Pages.Scan.route)
                                closeModal(Unit)
                            }
                        }
                        if (!hasCamera) {
                            twSubtitle {
                                +"Camera not found or not ready." // TODO translate
                            }
                        }
                        // MANUAL CODE INPUT
                        toggleManualInput.data.render { manualEnter ->
                            if (manualEnter) {
                                genericInput(
                                    value = scannedCodeStore.data.map { it.extOrIntObjIdOrActionId ?: "" },
                                ) {
                                    id("enterCodeManuallyInput")
                                    placeholder(TL.CodeScanning.INSERT_CODE_MANUALLY.getTranslationFlow())
                                    inputs.values() handledBy scannedCodeStore.updateCode
                                }
                                focusInputObserver({ js("document.getElementById('enterCodeManuallyInput').focus()") }, domNode)
                            } else {
                                div("flex w-full items-center justify-start") {
                                    twTextButton(
                                        text = TL.CodeScanning.INSTRUCTIONS_ENTER_MANUALLY.getTranslationFlow(),
                                        clickHandlers = listOf(toggleManualInput.setTrue),
                                    )
                                }
                            }
                        }

                        // Next Button
                        twPrimaryButton(
                            text = TL.General.NEXT,
                            disabledFlow = scannedCodeStore.data.map { it.extOrIntObjIdOrActionId == null },
                        ) {
                            clicks handledBy {
                                scannedCodeStore.checkManuallyEnteredCode(Unit)
                                closeModal(Unit)
                            }
                        }
                    }
                }
            }
        }
    }
}
